import _objectSpread from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
const CORE_V1_TO_V4 = {
  execute_block: {
    description: 'Execute the given block.',
    params: [{
      name: 'block',
      type: 'Block'
    }],
    type: 'Null'
  }
};
const CORE_V1_TO_V2 = {
  version: {
    description: 'Returns the version of the runtime.',
    params: [],
    type: 'RuntimeVersionPre3'
  }
};
const CORE_V2_TO_V4 = {
  initialize_block: {
    description: 'Initialize a block with the given header.',
    params: [{
      name: 'header',
      type: 'Header'
    }],
    type: 'Null'
  }
};
const CORE_V4_VERSION = {
  version: {
    description: 'Returns the version of the runtime.',
    params: [],
    type: 'RuntimeVersion'
  }
};
const CORE_V4_TO_V5 = _objectSpread(_objectSpread({}, CORE_V1_TO_V4), {}, {
  initialize_block: {
    description: 'Initialize a block with the given header.',
    params: [{
      name: 'header',
      type: 'Header'
    }],
    type: 'ExtrinsicInclusionMode'
  }
});
export const runtime = {
  Core: [{
    methods: _objectSpread(_objectSpread({}, CORE_V4_VERSION), CORE_V4_TO_V5),
    version: 5
  }, {
    methods: _objectSpread(_objectSpread(_objectSpread({}, CORE_V4_VERSION), CORE_V1_TO_V4), CORE_V2_TO_V4),
    version: 4
  }, {
    methods: _objectSpread(_objectSpread({
      version: {
        description: 'Returns the version of the runtime.',
        params: [],
        type: 'RuntimeVersionPre4'
      }
    }, CORE_V1_TO_V4), CORE_V2_TO_V4),
    version: 3
  }, {
    methods: _objectSpread(_objectSpread(_objectSpread({}, CORE_V1_TO_V2), CORE_V1_TO_V4), CORE_V2_TO_V4),
    version: 2
  }, {
    methods: _objectSpread(_objectSpread({
      initialise_block: {
        description: 'Initialize a block with the given header.',
        params: [{
          name: 'header',
          type: 'Header'
        }],
        type: 'Null'
      }
    }, CORE_V1_TO_V2), CORE_V1_TO_V4),
    version: 1
  }]
};